export default __webpack_public_path__ + "3343da5bcbba87263e7242cc1b3a59f9.svg";